import {ethers} from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { LPXv1_ABI } from "./abi/LPXv1_ABI";
import { LPXCtrlPools_v3ABI } from "./abi/LPXCtrlPools_v1ABI";
import { LPXReserves } from "./LPXContract";

export class LPXInfo{
    public configs_:LPXConfig[];
    public reserves_:LPXReserves[];
}
// export class LPXReserves{
//     public fundReserve:string;
//     public fundImgReserve:string;
//     public anchorReserve:string;
//     public anchorImgReserve:string;
// }
export class LPXConfig{
    public manager:string;
    public fundToken:string;
    public anchorToken:string;
    public ntzIndex:string;
    public rewardIndex:string;
    public startRatio:string;
    public sellRatio:string;
    public totalShares:string;
    public lastStartDropTimestamp:string;
}

export class LPXCtrlPoolsContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, LPXCtrlPools_v3ABI.GetABI(), provider);
    }
    
    //function poolStart(uint256 poolId_, ILPXv1.Reserve calldata reserve_) payable external
    async poolStart(valueEth:string, poolId:number, reserves:LPXReserves): Promise<any>
    {
        const result = await this._pay(this._toWei(valueEth), 'poolStart', poolId, reserves); 
        return result;
    }

    async addLiquidity(valueEth:string, poolId:number, fundValueEth:string, anchorValueEth:string): Promise<any>
    {
        const result = await this._pay(this._toWei(valueEth), 'addLiquidity', poolId, this._toWei(fundValueEth), this._toWei(anchorValueEth)); 
        return result;
    }

   // function claimProfits(uint256 poolId_, address[] calldata forUsers_, bool unsafe_) external lockThread {

    async claimProfits(poolId:number, forUsers:string[], unsafe:boolean=false): Promise<any>
    {
        const result = await this._send('claimProfits',poolId+"", forUsers, unsafe); 
        return result;
    }


    async removeLiquidity(poolId:number, partEth:string): Promise<any>
    {
        const result = await this._send('removeLiquidity', poolId+"", this._toWei(partEth)); 
        return result;
    }


    async getProfit(poolId:number, forAddress:string)
    {
        const res = await this._call("getProfit", poolId, forAddress);
        return this._toDecimal(res);
    }



    // async getPoolsByIds(poolsIds:number[]): Promise<LPXInfo>
    // {
    //     const response = await this._call("getPoolsByIds", poolsIds);
    //     if (!response) return;
    //     const pools = response as LPXInfo;
    //     const result = new LPXInfo();
    //     result.reserves_ = [];
    //     result.configs_ = [];
    //     for(let i=0;i<pools.configs_.length;i++)
    //     {
    //         let reserve = pools.reserves_[i];
    //         let config = pools.configs_[i];
    //         const res = new LPXReserves();
    //         res.fundReserve = this._toDecimal(reserve.fundReserve);
    //         res.fundImgReserve = this._toDecimal(reserve.fundImgReserve);
    //         res.anchorReserve = this._toDecimal(reserve.anchorReserve);
    //         res.anchorImgReserve = this._toDecimal(reserve.anchorImgReserve);
    //         result.reserves_.push(res);
    //         const cfg = new LPXConfig();
    //         cfg.manager = config.manager;
    //         cfg.fundToken = config.fundToken;
    //         cfg.anchorToken = config.anchorToken;
    //         cfg.ntzIndex = this._toDecimal(config.ntzIndex);
    //         cfg.rewardIndex = this._toDecimal(config.rewardIndex);
    //         cfg.startRatio = this._toDecimal(config.startRatio);
    //         cfg.sellRatio = this._toDecimal(config.sellRatio);
    //         cfg.totalShares = this._toDecimal(config.totalShares);
    //         result.configs_.push(cfg);
    //     }
    //     return result;
    // }

    // async lastPoolId()
    // {
    //     return await this._call("lastPoolId");
    // }

    // async share(poolId:number, address:string)
    // {
    //     const res = await this._call("share", poolId, address);
    //     return this._toDecimal(res);
    // }

}